/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import { theme } from "@nordcloud/gnui";
import { useTimeoutHover } from "~/tools/hooks/useTimeoutHover";

const OptionItem = styled.div`
  position: relative;
  background-color: transparent;
  color: inherit;
  cursor: default;
  font-size: inherit;
  width: 100%;
  user-select: none;
  box-sizing: border-box;
  display: flex;
  padding: ${theme.spacing.spacing02} ${theme.spacing.spacing03};
  &:hover {
    background-color: ${theme.color.interactive.secondary};
  }
`;

type InnerProps = {
  id: string;
  key: string;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  onMouseMove: React.MouseEventHandler<HTMLDivElement>;
  onMouseOver: React.MouseEventHandler<HTMLDivElement>;
  tabIndex: number;
};

type SelectPreviewItemProps = {
  data: {
    label: string;
    value: string;
  };
  children: React.ReactNode;
  innerProps: InnerProps;
  setSelectedService: React.Dispatch<
    React.SetStateAction<{
      name: string;
      value: string;
    }>
  >;
};

function SelectPreviewItem({
  data,
  children,
  innerProps,
  setSelectedService,
}: SelectPreviewItemProps) {
  const { setTimeoutHoverAction, clearTimeoutHover } = useTimeoutHover();

  return (
    <OptionItem
      {...innerProps}
      onMouseEnter={() =>
        setTimeoutHoverAction(
          () =>
            setSelectedService({
              name: data.label,
              value: data.value,
            }),
          300
        )
      }
      onMouseLeave={() => clearTimeoutHover()}
    >
      {children}
    </OptionItem>
  );
}

export { SelectPreviewItem };
